import React, { useState } from "react";
import ClinicianDetailsModal from "../../pages/clinicianPage/ClinicianDetailsModal";

const ClinicianDetailsCard = ({ clinician, isNew }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleViewDetails = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const getGreeting = () => {
    const currentHour = new Date().getHours();
    return currentHour < 12
      ? "Good Morning"
      : currentHour < 18
      ? "Good Afternoon"
      : "Good Evening";
  };

  return (
    <>
      <button
        onClick={handleViewDetails}
        className="group flex w-full items-center rounded-sm border border-gray-300 bg-white px-3 md:px-4 py-3 md:py-2.5 text-left transition-all hover:border-gray-300 hover:ring-1 hover:ring-indigo-500 hover:bg-gray-50">
        <div className="min-w-0 flex-1">
          <h1 className="text-base md:text-lg font-semibold text-gray-900">
            {getGreeting()}, {clinician.firstName} {clinician.lastName}
          </h1>
          <dl className="text-xs md:text-sm text-gray-500 md:mt-1">
            {clinician.role?.length ? (
              clinician.role.map((role, index) => (
                <span key={index}>
                  {role}
                  {index < clinician.role.length - 1 && ", "}
                </span>
              ))
            ) : (
              <span>No role assigned</span>
            )}
          </dl>
        </div>

        {/* <span className="ml-3 text-xs font-medium text-gray-500 group-hover:text-gray-700">
          View
        </span> */}
      </button>

      {isModalOpen && (
        <ClinicianDetailsModal
          clinicianId={clinician._id}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
};

export default ClinicianDetailsCard;
